import Alpine from "alpinejs";

Alpine.directive("money", (el, { expression }, { effect, evaluateLater }) => {
  const evaluate = evaluateLater(expression);

  let locale = Shopify?.locale || "en";
  let country = Shopify?.country || "GB";
  let currency = Shopify?.currency.active || "GBP";

  const currencyFormatter = new Intl.NumberFormat(`${locale}-${country}`, {
    style: "currency",
    currency: currency,
  });

  effect(() => {
    evaluate((value) => {
      let price =
        typeof value === "string" && value.trim() === ""
          ? 0.0
          : parseFloat(value);

      if (isNaN(price)) {
        price = 0.0;
      }

      el.innerText = currencyFormatter.format(price);
    });
  });
});
